import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import HeaderContainer from '../../../../container/SectionContainer/Lazy';
import NavbarAuth from '../../../../container/NavbarContainer/Lazy';
import HeaderImg from '../../../../assets/img/bg-poli.svg';
import FooterSection from '../../../../container/FooterContainer/Lazy';
import style from './style.module.css';

function PoliGate() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const choices = [
    {
      key: 'umum',
      icon: '🏥',
      iconClass: style.iconUmum,
      title: t('general.general'),
      desc: t('poli.generalDesc'),
      to: '/poli/jadwal',
    },
    {
      key: 'jkn',
      icon: '📱',
      iconClass: style.iconJkn,
      title: 'JKN (BPJS)',
      desc: t('poli.jknShortDesc'),
      to: '/poli/jkn',
    },
  ];

  return (
    <>
      <NavbarAuth />
      <HeaderContainer
        title={t('poli.gateTitle')}
        subtitle={t('poli.gateSubtitle')}
        image={HeaderImg}
        isSmall
      />
      <Container className="pt-5 pb-5">
        <h2 className="font-poppins-900">{t('poli.registerAs')}</h2>
        <p className="text-muted mb-4">{t('poli.registerAsSub')}</p>
        {choices.map((choice) => (
          <button
            key={choice.key}
            type="button"
            className={style.choice}
            onClick={() => navigate(choice.to)}
          >
            <span className={`${style.icon} ${choice.iconClass}`} aria-hidden="true">{choice.icon}</span>
            <span className={style.text}>
              <b>{choice.title}</b>
              <span>{choice.desc}</span>
            </span>
            <span className={style.arrow} aria-hidden="true">›</span>
          </button>
        ))}
      </Container>
      <FooterSection />
    </>
  );
}

export default React.memo(PoliGate);
